import { AxiosResponse } from "axios";
import { AutoCompleteDataModelDtoPaginatedList, UserSelectionEntityType, UserSuggestionsType } from "generated/CoreApi_v1";
import { coreApiV1 } from "providers/CoreApiProvider";

function getMembers(searchText: string): Promise<AxiosResponse<AutoCompleteDataModelDtoPaginatedList>> {
    const inputValue = searchText.trim().toLowerCase();
    return coreApiV1.suggestions.users({ pageNumber: 1, pageSize: 10, searchText: inputValue, type: UserSuggestionsType.Any, includeYourself: true, selectionHistoryType: UserSelectionEntityType.User });
}

export const peopleMentionBaseConfig = {
    allowedChars: /^[A-Za-z\sÁÉÍÓÚáéíóúÀÈÌÒÙàèìòùÇçÃãÕõÂÊÎÔÛãêîôûÅÄÖåäö]*$/,
    mentionDenotationChars: ["@"],
    dataAttributes: [
        "id",
        "value",
        "denotationChar",
        "link",
        "target",
        "disabled",
        "ot"
    ],
    positioningStrategy: "fixed",
};

export const peopleMentionConfig = {
    mention: {
        ...peopleMentionBaseConfig,
        source: function (searchTerm: any, renderList: any, mentionChar: any) {

            const inputValue = searchTerm.trim().toLowerCase();
            if (mentionChar === "@") {
                coreApiV1.suggestions.users({ pageNumber: 1, pageSize: 10, searchText: inputValue, type: UserSuggestionsType.Any, includeYourself: true, selectionHistoryType: UserSelectionEntityType.User });
                getMembers(searchTerm)
                    .then((users) => {
                        var values = users.data.items.map((d) => ({ id: d.key, ot: "user", value: d.label }));
                        renderList(values, searchTerm);
                    })
                    .catch(() => {
                        renderList([], searchTerm);
                    });
            }

        }
    }
};
